import { Button } from "@/components/ui/button";
import { usePaywallModal } from "@/contexts/PaywallModalContext";

export function PaywallModalTrigger({ children }: { children?: React.ReactNode }) {
  const { openPaywall } = usePaywallModal();
  return (
    <Button onClick={() => openPaywall("upgrade_cta")} variant="default" size="lg">
      {children ?? "Unlock My Business Intelligence"}
    </Button>
  );
}
